import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

export interface ITableDataItem {
    ChildItems: Array<any>;

    [prop: string]: any;
}

export interface ITableSchemaColumn {
    sortProp?: string;
    prop: string;
    arrayProp?: string;
    title: string;
    type: string;
    sortable?: boolean;
    tooltipText?: string;
}

export interface ITableSchema {
    columns: Array<ITableSchemaColumn>;
}

@Component({
    selector: 'fi-checklist-report-view-checkpoints-per-unit-table',
    templateUrl: './checkpoints-per-unit-table.component.html',
    standalone: false,
})
export class CheckpointsPerUnitTableComponent implements OnChanges {
    @Input() tableData: Array<ITableDataItem>;
    @Input() tableSchema: ITableSchema;
    @Input() selectedStatus;

    @Output() tableCellClick = new EventEmitter();

    displayData: Array<ITableDataItem>;

    sortOrder = {
        prop: 'Name',
        reverse: false,
    };

    ngOnChanges() {
        this._rebuildDisplayData();
    }

    // note: not used
    tableHeaderClick($event: MouseEvent, column: ITableSchemaColumn) {
        $event.preventDefault();

        if (!column.sortable) {
            return false;
        }

        if (this.sortOrder.prop === column.prop) {
            this.sortOrder.reverse = !this.sortOrder.reverse;
        } else {
            this.sortOrder.prop = column.prop;
            this.sortOrder.reverse = false;
        }

        this._rebuildDisplayData();
    }

    _rebuildDisplayData() {
        this.tableSchema = { columns: this.tableSchema.columns.slice() };

        const prop = this.sortOrder.prop === 'Name' ? 'NameForSorting' : this.sortOrder.prop,
            sortK = this.sortOrder.reverse ? -1 : 1,
            arrays = this.tableSchema.columns.filter((column) => column.type === 'array');

        this.displayData = this.tableData.slice().sort(compareFunc);
        this.displayData.forEach((parentItem) => {
            parentItem.ChildItems.sort(compareFunc);

            if (arrays.length) {
                parentItem.ChildItems = parentItem.ChildItems.reduce((previousValue, currentValue) => {
                    const values = currentValue[arrays[0].arrayProp];
                    if (!values) {
                        return previousValue;
                    }

                    const arrayItemsCount = values.length;

                    if (arrayItemsCount > 0) {
                        currentValue.$$_arrayData = createArrayData(arrays, currentValue, 0);
                        previousValue.push(currentValue);
                    }

                    if (arrayItemsCount > 1) {
                        for (let i = 1; i < arrayItemsCount; i++) {
                            const dataItem: any = {};
                            this.tableSchema.columns.forEach((column) => {
                                dataItem[column.prop] = null;
                            });
                            dataItem.$$_arrayData = createArrayData(arrays, currentValue, i);
                            previousValue.push(dataItem);
                        }
                    }

                    return previousValue;
                }, []);
            }
        });

        function compareFunc(a, b) {
            if (a[prop] < b[prop]) return -1 * sortK;
            if (a[prop] > b[prop]) return 1 * sortK;
            return 0;
        }

        function createArrayData(arrays: Array<ITableSchemaColumn>, childItem, index) {
            const result = {};
            arrays.forEach((column) => {
                result[column.prop] = childItem[column.arrayProp][index][column.prop];
            });
            return result;
        }
    }

    // note: not used
    cellClick($event) {
        this.tableCellClick.emit($event);
    }
}
